__turbopack_context__.v({
  "className": "helvetica_9cc79d77-module__xv2D7W__className",
});
